import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { useAuthStore } from '../../store/authStore'

export interface AccountLimits {
  owned: number
  max: number | null
  tier_code: string
  is_over_cap: boolean
  is_unlimited: boolean
  has_admin_override: boolean
}

const ACCOUNT_LIMITS_QUERY_KEY = ['accountLimits'] as const

export function useAccountLimits() {
  const { user } = useAuthStore()

  return useQuery<AccountLimits>({
    queryKey: [...ACCOUNT_LIMITS_QUERY_KEY, user?.id],
    queryFn: async () => {
      const res = await api.get('/accounts/limits')
      return res.data
    },
    enabled: !!user,
    staleTime: 30_000,
    gcTime: 300_000,
  })
}
